<!--
  ~ Copyright (C) 2026 DV Bern AG, Switzerland
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<!-- Unfortunately we have to use a lot of !important. kiBon has a lot of legacy styling issues. Fixing these would lead to
bigger adjustments which would increase the scope of the task which would make it infeasible-->
<div
    class="tw:flex tw:justify-center tw:items-end tw:gap-4 margin-bottom-20 versendete-mail-filter-material-overrides tw:wrap"
>
    <input
        class="tw:outline! tw:outline-[2px]! tw:min-w-[130px]"
        matInput
        type="text"
        [(ngModel)]="subjectOrReceiver"
        placeholder="{{ 'VERSENDETE_MAILS_SUCHE_PLATZHALTER' | translate }}"
        data-test="SearchBarSentMails"
    />

    <div
        class="tw:flex tw:flex-col tw:gap-1"
        role="group"
        aria-labelledby="vonGroupLabel"
    >
        <span
            id="vonGroupLabel"
            class="tw:text-lg! tw:font-semibold! tw:uppercase! tw:tracking-wide! tw:text-gray-500!"
            translate
            >VON</span
        >
        <div class="tw:flex tw:gap-2">
            <mat-form-field floatLabel="always" class="tw:max-w-[130px]!">
                <mat-label><span translate>DATUM</span></mat-label>
                <input
                    matInput
                    class="tw:outline-hidden! tw:bg-transparent! tw:p-0! tw:text-[1.6rem]!"
                    [matDatepicker]="datepickerFrom"
                    [ngModel]="startDate"
                    (ngModelChange)="setStartDate($event)"
                />
                <mat-datepicker #datepickerFrom />
                <mat-datepicker-toggle
                    [for]="datepickerFrom"
                    matSuffix
                    class="ignore-kibon-legacy"
                />
            </mat-form-field>

            <mat-form-field floatLabel="always" class="tw:max-w-[130px]!">
                <mat-label><span translate>ZEIT</span></mat-label>
                <input
                    matInput
                    class="tw:outline-hidden! tw:bg-transparent! tw:p-0! tw:text-[1.6rem]!"
                    [matTimepicker]="timepickerFrom"
                    [(ngModel)]="startDate"
                    [ngModelOptions]="{updateOn: 'blur'}"
                />
                <mat-timepicker #timepickerFrom />
                <mat-timepicker-toggle [for]="timepickerFrom" matSuffix />
            </mat-form-field>
        </div>
    </div>

    <mat-icon fontIcon="arrow_right_alt" class="tw:shrink-0"></mat-icon>

    <div
        class="tw:flex tw:flex-col tw:gap-1"
        role="group"
        aria-labelledby="bisGroupLabel"
    >
        <span
            id="bisGroupLabel"
            class="tw:text-lg! tw:font-semibold! tw:uppercase! tw:racking-wide! tw:text-gray-500!"
            translate
            >BIS</span
        >
        <div class="tw:flex tw:gap-2">
            <mat-form-field floatLabel="always" class="tw:max-w-[130px]!">
                <mat-label><span translate>DATUM</span></mat-label>
                <input
                    matInput
                    class="tw:outline-hidden! tw:bg-transparent! tw:text-[1.6rem]!"
                    [matDatepicker]="datepickerTo"
                    [ngModel]="endDate"
                    (ngModelChange)="setEndDate($event)"
                />
                <mat-datepicker #datepickerTo />
                <mat-datepicker-toggle
                    [for]="datepickerTo"
                    matSuffix
                    class="ignore-kibon-legacy"
                />
            </mat-form-field>

            <mat-form-field floatLabel="always" class="tw:max-w-[130px]!">
                <mat-label><span translate>ZEIT</span></mat-label>
                <input
                    matInput
                    class="tw:outline-hidden! tw:bg-transparent! tw:p-0! tw:text-[1.6rem]!"
                    [matTimepicker]="timepickerTo"
                    [(ngModel)]="endDate"
                    [ngModelOptions]="{updateOn: 'blur'}"
                />
                <mat-timepicker #timepickerTo />
                <mat-timepicker-toggle [for]="timepickerTo" matSuffix />
            </mat-form-field>
        </div>
    </div>
</div>
